import { apiClient } from '@/api/index.js';

// В успешном ответе items
async function getDescriptionsByKey({ key, entity }) {
  let url = '';

  switch (key) {
    // типы activity
    case 'activityType':
      url = '/api/Activity/GetActivityDescriptions';
      break;

    // типы соцсетей для формы personal data
    case 'socialNetworkType':
      url = '/api/SocialNetwork/GetSocialNetworkTypeDescriptions';
      break;

    // уровни для activity cv
    case 'activityCVLevel':
      url = '/api/Activity/GetActivityCVLevelDescriptions';
      break;

    // уровни для скиллов в activity cv
    case 'skillLevel':
      url = '/api/Activity/GetSkillLevelDescriptions';
      break;
  }

  const { data } = await apiClient({
    method: 'get',
    url,
    isAuthCheckSkipped: true,
    params: { Entity: entity },
  });

  return data;
}

export { getDescriptionsByKey };
